define(["exports", "../core/utils", "./templates/cgbg-headers", "./templates/cgbg-sotd", "./templates/headers", "hyperhtml", "../core/pubsubhub", "./templates/sotd"], function (_exports, _utils, _cgbgHeaders, _cgbgSotd, _headers, _hyperhtml, _pubsubhub, _sotd) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _cgbgHeaders = _interopRequireDefault(_cgbgHeaders);
  _cgbgSotd = _interopRequireDefault(_cgbgSotd);
  _headers = _interopRequireDefault(_headers);
  _hyperhtml = _interopRequireDefault(_hyperhtml);
  _sotd = _interopRequireDefault(_sotd);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["", ""]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "w3c/headers";
  _exports.name = name;
  const W3CDate = new Intl.DateTimeFormat(["en-AU"], {
    timeZone: "UTC",
    year: "numeric",
    month: "long",
    day: "2-digit"
  });
  const status2maturity = {
    LS: "WD",
    LD: "WD",
    FPWD: "WD",
    LC: "WD",
    FPLC: "WD",
    "FPWD-NOTE": "NOTE",
    "WD-NOTE": "WD",
    "LC-NOTE": "LC",
    "IG-NOTE": "NOTE",
    "WG-NOTE": "NOTE"
  };
  const status2rdf = {
    NOTE: "w3p:NOTE",
    WD: "w3p:WD",
    LC: "w3p:LastCall",
    CR: "w3p:CR",
    PR: "w3p:PR",
    REC: "w3p:REC",
    PER: "w3p:PER",
    RSCND: "w3p:RSCND"
  };
  const status2text = {
    NOTE: "Working Group Note",
    "WG-NOTE": "Working Group Note",
    "CG-NOTE": "Co-ordination Group Note",
    "IG-NOTE": "Interest Group Note",
    "Member-SUBM": "Member Submission",
    "Team-SUBM": "Team Submission",
    MO: "Member-Only Document",
    ED: "Editor's Draft",
/* EEA specStatus added */
    EEA: "EEA Editor's Draft",
    LS: "Living Standard",
    LD: "Living Document",
    FPWD: "First Public Working Draft",
    WD: "Working Draft",
    "FPWD-NOTE": "Working Group Note",
    "WD-NOTE": "Working Draft",
    "LC-NOTE": "Working Draft",
    FPLC: "First Public and Last Call Working Draft",
    LC: "Last Call Working Draft",
    CR: "Candidate Recommendation",
    PR: "Proposed Recommendation",
    PER: "Proposed Edited Recommendation",
    REC: "Recommendation",
    RSCND: "Rescinded Recommendation",
    unofficial: "Unofficial Draft",
    base: "Document",
    finding: "TAG Finding",
    "draft-finding": "Draft TAG Finding",
    "CG-DRAFT": "Draft Community Group Report",
    "CG-FINAL": "Final Community Group Report",
    "BG-DRAFT": "Draft Business Group Report",
    "BG-FINAL": "Final Business Group Report"
  };

  const status2long = _objectSpread({}, status2text, {
    "FPWD-NOTE": "First Public Working Group Note",
    "LC-NOTE": "Last Call Working Draft"
  });

  const maybeRecTrack = ["FPWD", "WD"];
  const recTrackStatus = ["FPLC", "LC", "CR", "PR", "PER", "REC"];
  const noTrackStatus = ["base", "BG-DRAFT", "BG-FINAL", "CG-DRAFT", "CG-FINAL", "draft-finding", "finding", "MO", "unofficial"];
  const cgbg = ["CG-DRAFT", "CG-FINAL", "BG-DRAFT", "BG-FINAL"];
/* EEA specStatus added */
  const precededByAn = ["ED", "IG-NOTE", "EEA"];
  const licenses = {
    cc0: {
      name: "Creative Commons 0 Public Domain Dedication",
      short: "CC0",
      url: "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    "w3c-software": {
      name: "W3C Software Notice and License",
      short: "W3C Software",
      url: "https://www.w3.org/Consortium/Legal/2002/copyright-software-20021231"
    },
    "w3c-software-doc": {
      name: "W3C Software and Document Notice and License",
      short: "W3C Software and Document",
      url: "https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document"
    },
    "cc-by": {
      name: "Creative Commons Attribution 4.0 International Public License",
      short: "CC-BY",
      url: "https://creativecommons.org/licenses/by/4.0/legalcode"
    },
/* EEA license */
    "eea": {
      name: "Enterprise Ethereum Alliance License",
      short: "EEA License",
      url: "https://member.entethalliance.org/HigherLogic/System/DownloadDocumentFile.ashx?DocumentFileKey=df755162-8ea4-93c5-6f43-4978c6be2841&forceDialog=0"
    }
  };
  const baseLogo = Object.freeze({
    id: "",
    alt: "",
    href: "",
    src: "",
    height: "48",
    width: "72"
  });
  /**
   * @param {*} conf
   * @param {string} prop
   * @param {string | number | Date} fallbackDate
   */

  function validateDateAndRecover(conf, prop, fallbackDate = new Date()) {
    const date = conf[prop] ? new Date(conf[prop]) : new Date(fallbackDate); // if date is valid

    if (Number.isFinite(date.valueOf())) {
      const formattedDate = _utils.ISODate.format(date);

      return new Date(formattedDate);
    }

    const msg = "[`".concat(prop, "`](https://github.com/w3c/respec/wiki/").concat(prop, ") ") + "is not a valid date: \"".concat(conf[prop], "\". Expected format 'YYYY-MM-DD'.");
    (0, _pubsubhub.pub)("error", msg);
    return new Date(_utils.ISODate.format(new Date()));
  }

  function run(conf) {
    conf.isUnofficial = conf.specStatus === "unofficial";

    if (conf.isUnofficial && !Array.isArray(conf.logos)) {
      conf.logos = [];
    }

    conf.isCCBY = conf.license === "cc-by";
    conf.isW3CSoftAndDocLicense = conf.license === "w3c-software-doc";

    if (["cc-by"].includes(conf.license)) {
      let msg = "You cannot use license \"`".concat(conf.license, "`\" with W3C Specs. ");
      msg += "Please set `respecConfig.license: \"w3c-software-doc\"` instead.";
      (0, _pubsubhub.pub)("error", msg);
    }

    conf.licenseInfo = licenses[conf.license];
    conf.isCGBG = cgbg.includes(conf.specStatus);
    conf.isCGFinal = conf.isCGBG && conf.specStatus.endsWith("G-FINAL");
    conf.isBasic = conf.specStatus === "base";
    conf.isRegular = !conf.isCGBG && !conf.isBasic;

    if (!conf.specStatus) {
      (0, _pubsubhub.pub)("error", "Missing required configuration: `specStatus`");
    }

    if (conf.isRegular && !conf.shortName) {
      (0, _pubsubhub.pub)("error", "Missing required configuration: `shortName`");
    }

    if (conf.testSuiteURI) {
      const url = new URL(conf.testSuiteURI, location.href);
      const {
        host,
        pathname
      } = url;

      if (host === "github.com" && pathname.startsWith("/w3c/web-platform-tests/")) {
        const msg = "Web Platform Tests have moved to a new Github Organization at https://github.com/web-platform-tests. " + "Please update your [`testSuiteURI`](https://github.com/w3c/respec/wiki/testSuiteURI) to point to the " + "new tests repository (e.g., https://github.com/web-platform-tests/wpt/".concat(conf.shortName, " ).");
        (0, _pubsubhub.pub)("warn", msg);
      }
    }

    conf.title = document.title || "No Title";

    if (document.title && conf.isPreview && conf.prNumber) {
      document.title = "Preview of PR #".concat(conf.prNumber, ": ").concat(document.title);
    }

    if (!conf.subtitle) conf.subtitle = "";
    conf.publishDate = validateDateAndRecover(conf, "publishDate", document.lastModified);
    conf.publishYear = conf.publishDate.getUTCFullYear();
    conf.publishHumanDate = W3CDate.format(conf.publishDate);
    conf.isNoTrack = noTrackStatus.includes(conf.specStatus);
    conf.isRecTrack = conf.noRecTrack ? false : recTrackStatus.concat(maybeRecTrack).includes(conf.specStatus);
    conf.isMemberSubmission = conf.specStatus === "Member-SUBM";

    if (conf.isMemberSubmission) {
      const memSubmissionLogo = {
        alt: "W3C Member Submission",
        href: "https://www.w3.org/Submission/",
        src: "https://www.w3.org/Icons/member_subm-v.svg",
        width: "211"
      };
      conf.logos.push(_objectSpread({}, baseLogo, {}, memSubmissionLogo));
    }

    conf.isTeamSubmission = conf.specStatus === "Team-SUBM";

    if (conf.isTeamSubmission) {
      const teamSubmissionLogo = {
        alt: "W3C Team Submission",
        href: "https://www.w3.org/TeamSubmission/",
        src: "https://www.w3.org/Icons/team_subm-v.svg",
        width: "211"
      };
      conf.logos.push(_objectSpread({}, baseLogo, {}, teamSubmissionLogo));
    }

    conf.isSubmission = conf.isMemberSubmission || conf.isTeamSubmission;
    conf.anOrA = precededByAn.includes(conf.specStatus) ? "an" : "a";
    conf.isTagFinding = conf.specStatus === "finding" || conf.specStatus === "draft-finding";

    if (!conf.edDraftURI) {
      conf.edDraftURI = "";
/* EEA specStatus */
      if (conf.specStatus === "ED" || conf.specStatus === "EEA") (0, _pubsubhub.pub)("warn", "Editor's Drafts should set edDraftURI.");
    }

    conf.maturity = status2maturity[conf.specStatus] ? status2maturity[conf.specStatus] : conf.specStatus;
    let publishSpace = "TR";
    if (conf.specStatus === "Member-SUBM") publishSpace = "Submission";else if (conf.specStatus === "Team-SUBM") publishSpace = "TeamSubmission";
    if (conf.isRegular) conf.thisVersion = "https://www.w3.org/".concat(publishSpace, "/").concat(conf.publishDate.getUTCFullYear(), "/").concat(conf.maturity, "-").concat(conf.shortName, "-").concat((0, _utils.concatDate)(conf.publishDate), "/");
    if (conf.specStatus === "ED") conf.thisVersion = conf.edDraftURI;
/* EEA specStatus */
    if (conf.specStatus === "EEA") conf.thisVersion = conf.edDraftURI;
    if (conf.isRegular) conf.latestVersion = "https://www.w3.org/".concat(publishSpace, "/").concat(conf.shortName, "/");

    if (conf.isTagFinding) {
      conf.latestVersion = "https://www.w3.org/2001/tag/doc/".concat(conf.shortName);
      conf.thisVersion = "".concat(conf.latestVersion, "-").concat(_utils.ISODate.format(conf.publishDate));
    }

    if (conf.previousPublishDate) {
      if (!conf.previousMaturity && !conf.isTagFinding) {
        (0, _pubsubhub.pub)("error", "`previousPublishDate` is set, but not `previousMaturity`.");
      }

      conf.previousPublishDate = validateDateAndRecover(conf, "previousPublishDate");
      const pmat = status2maturity[conf.previousMaturity] ? status2maturity[conf.previousMaturity] : conf.previousMaturity;

      if (conf.isTagFinding) {
        conf.prevVersion = "".concat(conf.latestVersion, "-").concat(_utils.ISODate.format(conf.previousPublishDate));
      } else if (conf.isCGBG) {
        conf.prevVersion = conf.prevVersion || "";
      } else if (conf.isBasic) {
        conf.prevVersion = "";
      } else {
        conf.prevVersion = "https://www.w3.org/TR/".concat(conf.previousPublishDate.getUTCFullYear(), "/").concat(pmat, "-").concat(conf.shortName, "-").concat((0, _utils.concatDate)(conf.previousPublishDate), "/");
      }
    } else {
/* EEA specstatus */
      if (!conf.specStatus.endsWith("NOTE") && conf.specStatus !== "FPWD" && conf.specStatus !== "FPLC" && conf.specStatus !== "ED" && conf.specStatus !== "EEA" && !conf.noRecTrack && !conf.isNoTrack && !conf.isSubmission) (0, _pubsubhub.pub)("error", "Document on track but no previous version:" + " Add `previousMaturity`, and `previousPublishDate` to ReSpec's config.");
      if (!conf.prevVersion) conf.prevVersion = "";
    }

    if (conf.prevRecShortname && !conf.prevRecURI) conf.prevRecURI = "https://www.w3.org/TR/".concat(conf.prevRecShortname);

    const peopCheck = function peopCheck(it) {
      if (!it.name) (0, _pubsubhub.pub)("error", "All authors and editors must have a name.");

      if (it.orcid) {
        try {
          it.orcid = normalizeOrcid(it.orcid);
        } catch (e) {
          (0, _pubsubhub.pub)("error", "\"".concat(it.orcid, "\" is not an ORCID. ").concat(e.message)); // A failed orcid link could link to something outside of orcid,
          // which would be misleading.

          delete it.orcid;
        }
      }
    };

    if (!conf.formerEditors) conf.formerEditors = [];

    if (conf.editors) {
      conf.editors.forEach(peopCheck); // Move any editors with retiredDate to formerEditors.

      for (let i = 0; i < conf.editors.length; i++) {
        const editor = conf.editors[i];

        if ("retiredDate" in editor) {
          conf.formerEditors.push(editor);
          conf.editors.splice(i--, 1);
        }
      }
    }

    if (!conf.editors || conf.editors.length === 0) (0, _pubsubhub.pub)("error", "At least one editor is required");

    if (conf.formerEditors.length) {
      conf.formerEditors.forEach(peopCheck);
    }

    if (conf.authors) {
      conf.authors.forEach(peopCheck);
    }

    conf.multipleEditors = conf.editors && conf.editors.length > 1;
    conf.multipleFormerEditors = conf.formerEditors.length > 1;
    conf.multipleAuthors = conf.authors && conf.authors.length > 1;
    (conf.alternateFormats || []).forEach(it => {
      if (!it.uri || !it.label) {
        (0, _pubsubhub.pub)("error", "All alternate formats must have a uri and a label.");
      }
    });
    conf.multipleAlternates = conf.alternateFormats && conf.alternateFormats.length > 1;
    conf.alternatesHTML = conf.alternateFormats && (0, _utils.joinAnd)(conf.alternateFormats, alt => {
      let optional = alt.hasOwnProperty("lang") && alt.lang ? " hreflang='".concat(alt.lang, "'") : "";
      optional += alt.hasOwnProperty("type") && alt.type ? " type='".concat(alt.type, "'") : "";
      return "<a rel='alternate' href='".concat(alt.uri, "'").concat(optional, ">").concat(alt.label, "</a>");
    });

    if (conf.bugTracker) {
      if (conf.bugTracker.new && conf.bugTracker.open) {
        conf.bugTrackerHTML = "<a href='".concat(conf.bugTracker.new, "'>").concat(conf.l10n.file_a_bug, "</a> ").concat(conf.l10n.open_parens, "<a href='").concat(conf.bugTracker.open, "'>").concat(conf.l10n.open_bugs, "</a>").concat(conf.l10n.close_parens);
      } else if (conf.bugTracker.open) {
        conf.bugTrackerHTML = "<a href='".concat(conf.bugTracker.open, "'>open bugs</a>");
      } else if (conf.bugTracker.new) {
        conf.bugTrackerHTML = "<a href='".concat(conf.bugTracker.new, "'>file a bug</a>");
      }
    }

    if (conf.copyrightStart && conf.copyrightStart == conf.publishYear) conf.copyrightStart = "";
    conf.longStatus = status2long[conf.specStatus];
    conf.textStatus = status2text[conf.specStatus];

    if (status2rdf[conf.specStatus]) {
      conf.rdfStatus = status2rdf[conf.specStatus];
    }

    conf.showThisVersion = !conf.isNoTrack || conf.isTagFinding;
/* EEA specStatus */
    conf.showPreviousVersion = conf.specStatus !== "FPWD" && conf.specStatus !== "FPLC" && conf.specStatus !== "ED" && conf.specStatus !== "EEA" && !conf.isNoTrack && !conf.isSubmission;
    if (conf.specStatus.endsWith("NOTE") && !conf.prevVersion) conf.showPreviousVersion = false;
    if (conf.isTagFinding) conf.showPreviousVersion = conf.previousPublishDate ? true : false;
    conf.notYetRec = conf.isRecTrack && conf.specStatus !== "REC";
    conf.isRec = conf.isRecTrack && conf.specStatus === "REC";
    if (conf.isRec && !conf.errata) (0, _pubsubhub.pub)("error", "Recommendations must have an errata link.");
    conf.notRec = conf.specStatus !== "REC";
    conf.prependW3C = !conf.isUnofficial;
    conf.isED = conf.specStatus === "ED";
/* EEA specStatus */
    conf.isEEA = conf.specStatus === "EEA";
    conf.isCR = conf.specStatus === "CR";
    conf.isPR = conf.specStatus === "PR";
    conf.isPER = conf.specStatus === "PER";
    conf.isMO = conf.specStatus === "MO";
    conf.isNote = ["FPWD-NOTE", "WG-NOTE"].includes(conf.specStatus);
    conf.isIGNote = conf.specStatus === "IG-NOTE";
    conf.dashDate = _utils.ISODate.format(conf.publishDate);
    conf.publishISODate = conf.publishDate.toISOString();
    conf.shortISODate = _utils.ISODate.format(conf.publishDate);

    if (conf.hasOwnProperty("wgPatentURI") && !Array.isArray(conf.wgPatentURI)) {
      Object.defineProperty(conf, "wgId", {
        get() {
          // it's always at "pp-impl" + 1
          const urlParts = this.wgPatentURI.split("/");
          const pos = urlParts.findIndex(item => item === "pp-impl") + 1;
          return urlParts[pos] || "";
        }

      });
    } else {
      conf.wgId = conf.wgId ? conf.wgId : "";
    } // configuration done - yay!
    // insert into document


    const header = (conf.isCGBG ? _cgbgHeaders.default : _headers.default)(conf);
    document.body.prepend(header);
    document.body.classList.add("h-entry"); // handle SotD

    const sotd = document.getElementById("sotd") || document.createElement("section");

    if ((conf.isCGBG || !conf.isNoTrack || conf.isTagFinding) && !sotd.id) {
      (0, _pubsubhub.pub)("error", "A custom SotD paragraph is required for your type of document.");
    }

    sotd.id = sotd.id || "sotd";
    sotd.classList.add("introductory"); // NOTE:
    //  When arrays, wg and wgURI have to be the same length (and in the same order).
    //  Technically wgURI could be longer but the rest is ignored.
    //  However wgPatentURI can be shorter. This covers the case where multiple groups
    //  publish together but some aren't used for patent policy purposes (typically this
    //  happens when one is foolish enough to do joint work with the TAG). In such cases,
    //  the groups whose patent policy applies need to be listed first, and wgPatentURI
    //  can be shorter — but it still needs to be an array.

    const wgPotentialArray = [conf.wg, conf.wgURI, conf.wgPatentURI];

    if (wgPotentialArray.some(item => Array.isArray(item)) && !wgPotentialArray.every(item => Array.isArray(item))) {
      (0, _pubsubhub.pub)("error", "If one of '`wg`', '`wgURI`', or '`wgPatentURI`' is an array, they all have to be.");
    }

    if (conf.isCGBG && !conf.wg) {
      (0, _pubsubhub.pub)("error", "[`wg`](https://github.com/w3c/respec/wiki/wg)" + " configuration option is required for this kind of document.");
    }

    if (Array.isArray(conf.wg)) {
      conf.multipleWGs = conf.wg.length > 1;
      conf.wgHTML = (0, _utils.joinAnd)(conf.wg, (wg, idx) => {
        return "the <a href='".concat(conf.wgURI[idx], "'>").concat(wg, "</a>");
      });
      const pats = [];

      for (let i = 0, n = conf.wg.length; i < n; i++) {
        pats.push("a <a href='".concat(conf.wgPatentURI[i], "' rel='disclosure'>") + "public list of any patent disclosures  (".concat(conf.wg[i], ")</a>"));
      }

      conf.wgPatentHTML = (0, _utils.joinAnd)(pats);
    } else {
      conf.multipleWGs = false;

      if (conf.wg) {
        conf.wgHTML = "the <a href='".concat(conf.wgURI, "'>").concat(conf.wg, "</a>");
      }
    }

    if (conf.specStatus === "PR" && !conf.crEnd) {
      (0, _pubsubhub.pub)("error", "`specStatus` is \"PR\" but no `crEnd` is specified (needed to indicate end of previous CR).");
    }

    if (conf.specStatus === "CR" && !conf.crEnd) {
      (0, _pubsubhub.pub)("error", "`specStatus` is \"CR\", but no `crEnd` is specified in Respec config.");
    }

    conf.crEnd = validateDateAndRecover(conf, "crEnd");
    conf.humanCREnd = W3CDate.format(conf.crEnd);

    if (conf.specStatus === "PR" && !conf.prEnd) {
      (0, _pubsubhub.pub)("error", "`specStatus` is \"PR\" but no `prEnd` is specified.");
    }

    conf.prEnd = validateDateAndRecover(conf, "prEnd");
    conf.humanPREnd = W3CDate.format(conf.prEnd);

    if (conf.specStatus === "PER" && !conf.perEnd) {
      (0, _pubsubhub.pub)("error", "Status is PER but no perEnd is specified");
    }

    conf.perEnd = validateDateAndRecover(conf, "perEnd");
    conf.humanPEREnd = W3CDate.format(conf.perEnd);
    conf.recNotExpected = conf.noRecTrack || conf.recNotExpected ? true : !conf.isRecTrack && conf.maturity == "WD" && conf.specStatus !== "FPWD-NOTE";

    if (conf.noRecTrack && recTrackStatus.includes(conf.specStatus)) {
      (0, _pubsubhub.pub)("error", "Document configured as [`noRecTrack`](https://github.com/w3c/respec/wiki/noRecTrack), but its status (\"".concat(conf.specStatus, "\") puts it on the W3C Rec Track. Status cannot be any of: ").concat(recTrackStatus.join(", "), ". [More info](https://github.com/w3c/respec/wiki/noRecTrack)."));
    }

    if (conf.isIGNote && !conf.charterDisclosureURI) {
      (0, _pubsubhub.pub)("error", "IG-NOTEs must link to charter's disclosure section using `charterDisclosureURI`.");
    }

    _hyperhtml.default.bind(sotd)(_templateObject(), populateSoTD(conf, sotd));

    if (!conf.implementationReportURI && conf.isCR) {
      (0, _pubsubhub.pub)("error", "CR documents must have an [`implementationReportURI`](https://github.com/w3c/respec/wiki/implementationReportURI) " + "that describes [implementation experience](https://www.w3.org/2019/Process-20190301/#implementation-experience).");
    }

    if (!conf.implementationReportURI && conf.isPR) {
      (0, _pubsubhub.pub)("warn", "PR documents should include an " + " [`implementationReportURI`](https://github.com/w3c/respec/wiki/implementationReportURI)" + " that describes [implementation experience](https://www.w3.org/2019/Process-20190301/#implementation-experience).");
    } // Requested by https://github.com/w3c/respec/issues/504
    // Makes a record of a few auto-generated things.


    (0, _pubsubhub.pub)("amend-user-config", {
      publishISODate: conf.publishISODate,
      generatedSubtitle: "".concat(conf.longStatus, " ").concat(conf.publishHumanDate)
    });
  }
  /**
   * @param {*} conf
   * @param {HTMLElement} sotd
   */


  function populateSoTD(conf, sotd) {
    const options = _objectSpread({}, collectSotdContent(sotd, conf), {
      get mailToWGPublicList() {
        return "mailto:".concat(conf.wgPublicList, "@w3.org");
      },

      get mailToWGPublicListWithSubject() {
        const fragment = conf.subjectPrefix ? "?subject=".concat(encodeURIComponent(conf.subjectPrefix)) : "";
        return this.mailToWGPublicList + fragment;
      },

      get mailToWGPublicListSubscription() {
        return "mailto:".concat(conf.wgPublicList, "-request@w3.org?subject=subscribe");
      }

    });

    const template = conf.isCGBG ? _cgbgSotd.default : _sotd.default;
    return template(conf, options);
  }
  /**
   * @param {HTMLElement} sotd
   */


  function collectSotdContent(sotd, {
    isTagFinding = false
  }) {
    const sotdClone = sotd.cloneNode(true);
    const additionalContent = document.createDocumentFragment(); // we collect everything until we hit a section,
    // that becomes the custom content.

    while (sotdClone.hasChildNodes()) {
      if (isElement(sotdClone.firstChild) && sotdClone.firstChild.localName === "section") {
        break;
      }

      additionalContent.appendChild(sotdClone.firstChild);
    }

    if (isTagFinding && !additionalContent.hasChildNodes()) {
      (0, _pubsubhub.pub)("warn", "ReSpec does not support automated SotD generation for TAG findings, " + "please add the prerequisite content in the 'sotd' section");
    }

    return {
      additionalContent,
      // Whatever sections are left, we throw at the end.
      additionalSections: sotdClone.childNodes
    };
  }
  /**
   * @param {string} orcid Either an ORCID URL or just the 16-digit ID which comes after the /
   * @return {string} the full ORCID URL. Throws an error if the ID is invalid.
   */


  function normalizeOrcid(orcid) {
    const orcidUrl = new URL(orcid, "https://orcid.org/");

    if (orcidUrl.origin !== "https://orcid.org") {
      throw new Error("The origin should be \"https://orcid.org\", not \"".concat(orcidUrl.origin, "\"."));
    } // trailing slash would mess up checksum


    const orcidId = orcidUrl.pathname.slice(1).replace(/\/$/, "");

    if (!/^\d{4}-\d{4}-\d{4}-\d{3}(\d|X)$/.test(orcidId)) {
      throw new Error("ORCIDs have the format \"1234-1234-1234-1234\", not \"".concat(orcidId, "\""));
    } // calculate checksum as per https://support.orcid.org/hc/en-us/articles/360006897674-Structure-of-the-ORCID-Identifier


    const lastDigit = orcidId[orcidId.length - 1];
    const remainder = orcidId.split("").slice(0, -1).filter(c => /\d/.test(c)).map(Number).reduce((acc, c) => (acc + c) * 2, 0);
    const lastDigitInt = (12 - remainder % 11) % 11;
    const lastDigitShould = lastDigitInt === 10 ? "X" : String(lastDigitInt);

    if (lastDigit !== lastDigitShould) {
      throw new Error("\"".concat(orcidId, "\" has an invalid checksum."));
    }

    return orcidUrl.href;
  }
  /**
   * @param {Node} node
   * @return {node is Element}
   */


  function isElement(node) {
    return node.nodeType === Node.ELEMENT_NODE;
  }
});
//# sourceMappingURL=headers.js.map